<!-- Content -->
<form [formGroup]="TaskApportunityInfoForm" aria-label="task-opportunity-form">
  <div class="mb-3" aria-label="task-title-section">
    <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="task-title-label">{{'Shared.TASK-OPPORTUNITY-INFO.TASK-TITLE' | translate}}</h3>
    @if (!taskTitleEdit) {
      <p
        (click)="taskTitleEdit = true"
        class="mb-0 font-bold text-sm md:text-base cursor-pointer border-round hover:surface-200"
        data-testid="task-title-display">
        {{modelData().latest_task?modelData().latest_task.title:modelData().title}}
      </p>
    }

    @if (taskTitleEdit) {
      <div class="p-inputgroup" aria-label="task-title-edit">
        <input type="text"
          class="w-full text-sm"
          pInputText
          formControlName="taskTitle"
          aria-label="task-title-input" />
          <button type="button"
            pButton
            pRipple
            icon="fa fa-check"
            (click)="EditTaskTitle(TaskApportunityInfoForm)"
            aria-label="save-task-title"
          ></button>
        </div>
      }
    </div>

    <div class="mb-4 border-bottom-1 border-300 pb-3 relative" aria-label="task-notes-section">
      <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="task-notes-label">{{'Shared.TASK-OPPORTUNITY-INFO.TASK-NOTES' | translate}}</h3>
      @if (!taskNotesEdit) {
        <div
          (click)="taskNotesEdit = false"
          class="mb-0 text-sm text-700"
          data-testid="task-notes-display">
          <span class="border-round">{{taskNotes | slice:0:100}}</span>
          @if (taskNotes.length > 100) {
            <span
              class="text-primary cursor-pointer font-bold d-inline-block ml-2 hover:underline"
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="scalein"
              leaveToClass="hidden"
              leaveActiveClass="fadeout"
              [hideOnOutsideClick]="true"
              data-testid="load-more-notes">
              {{'Shared.TASK-OPPORTUNITY-INFO.LOAD_MORE' | translate}}
            </span>
          }
          <div class="task-notes-more hidden surface-0 p-3 z-3 border-round absolute shadow-2 border-1 border-300 left-0 w-full text-sm"
            aria-label="task-notes-full">
            {{taskNotes}}
          </div>
        </div>
      }
      @if (taskNotesEdit) {
        <div class="p-inputgroup" aria-label="task-notes-edit">
          <input type="text"
            class="w-full text-sm"
            pInputText
            formControlName="taskNotes"
            aria-label="task-notes-input" />
            <button type="button"
              pButton
              pRipple
              icon="fa fa-check"
              (click)="EditTaskNotes(TaskApportunityInfoForm)"
              aria-label="save-task-notes"
            ></button>
          </div>
        }
      </div>

      <div class="grid" aria-label="task-details-grid">
        <div class="col-6" aria-label="category-type-section">
          <h3 class="text-xs text-600 mb-3 font-normal uppercase" aria-label="category-type-label">{{'Shared.TASK-OPPORTUNITY-INFO.CATEGORY_TYPE' | translate}}</h3>
          <p class="mb-0 -mt-1 font-bold" aria-label="category-type-value">
            {{modelData().latest_task ? modelData().latest_task.name_primary_language ?modelData().latest_task.name_primary_language :modelData().latest_task.name_secondary_language : modelData().name_primary_language }}
          </p>
        </div>
        <div class="col-6" aria-label="task-type-section">
          <h3 class="text-xs text-600 mb-3 font-normal uppercase" aria-label="task-type-label">{{'Shared.TASK-OPPORTUNITY-INFO.TASK-TYPE' | translate}}</h3>
          <p class="mb-0 -mt-1 font-bold" aria-label="task-type-value">
            <i class="fa fa-phone mr-2" aria-label="task-type-icon"></i>
            {{modelData().latest_task?modelData().latest_task.type:modelData().type }}
          </p>
        </div>
        <div class="col-6" aria-label="assigned-to-section">
          <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="assigned-to-label">{{'Shared.TASK-OPPORTUNITY-INFO.ASSIGNED-TO' | translate}}</h3>
          <div class="ml-0">
            <staff-selector [formGroup]="TaskApportunityInfoForm"
              [controlName]="SelectedAssignedFormControl"
              [id]="assignedTo$"
              [styleClass]="'border-none surface-50 w-full'"
              [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
              (selectedStaff)="getSelectedStaff($event)"
              aria-label="staff-selector" />
          </div>
        </div>
        <div class="col-6" aria-label="due-date-section">
          <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="due-date-label">{{'Shared.TASK-OPPORTUNITY-INFO.DUE' | translate}}</h3>
          @if (!dueDateEdit) {
            <strong
              (click)="openDueDateEdit()"
              class="text-sm block md:inline md:text-base -mt-2 p-1 -ml-1 md:mt-0 cursor-pointer border-round hover:surface-200"
              data-testid="due-date-display">
              {{TaskApportunityInfoForm.get('scheduled_date').value | datetimeformat: 'EE, MMMM d, y'}}
            </strong>
          }
          @if (dueDateEdit) {
            <div class="flex flex-nowrap align-items-stretch w-full gap-1" aria-label="due-date-edit">
              <p-datepicker [showIcon]="true"
                formControlName="scheduled_date"
                styleClass="w-full"
                class="flex-1 min-w-0"
                placeholder="Select Date"
                inputStyleClass="text-sm"
                (onSelect)="OnScheduleDateSelect($event)"
                [minDate]="minDateForEdit"
                [disabledDates]="disabledDatesForEdit"
              aria-label="due-date-picker" />
              <button type="button"
                pButton
                pRipple
                icon="fa fa-times"
                class="p-button-danger flex-shrink-0"
                (click)="dueDateEdit = false"
                aria-label="cancel-due-date"
              ></button>
            </div>
          }
        </div>
        @if (modelData().stage_master_id) {
          <div class="col-6" aria-label="convertibility-section">
            <h3 class="text-xs text-600 mb-0 font-normal uppercase" aria-label="convertibility-label">
              {{'Shared.TASK-OPPORTUNITY-INFO.CONVERTIBILITY' | translate}}
            </h3>
            <div class="-ml-3">
              <p-select [options]="convertibility"
                formControlName="ddlselectedConvertibility"
                optionLabel="name"
                styleClass="border-none surface-50"
                (onChange)="UpdateConvartability($event,TaskApportunityInfoForm)"
                aria-label="convertibility-dropdown">
                <ng-template pTemplate="selectedItem">
                  @if (SelectedConvertibility) {
                    <div class="flex align-items-center">
                      <span class="mr-2">
                        <img width="20"
                          src="{{SelectedConvertibility.icon}}"
                          alt="{{SelectedConvertibility.name}}"
                          aria-label="convertibility-icon" />
                        </span>
                        <strong class="text-900" aria-label="convertibility-value">{{SelectedConvertibility.name}}</strong>
                      </div>
                    }
                  </ng-template>
                  <ng-template let-convertibility pTemplate="item">
                    <div class="flex align-items-center">
                      <span class="mr-2">
                        <img width="20"
                          class="grayscale opacity-50"
                          src="{{convertibility.icon}}"
                          alt="{{convertibility.name}}"
                          aria-label="convertibility-option-icon" />
                        </span>
                        <div class="text-sm text-600" aria-label="convertibility-option-name">{{convertibility.name}}</div>
                      </div>
                    </ng-template>
                  </p-select>
                </div>
              </div>
            }
            @if (modelData().stage_master_id) {
              <div class="col-6" aria-label="opportunity-stage-section">
                <h3 class="text-xs text-600 mb-0 font-normal uppercase" aria-label="opportunity-stage-label">
                  {{'Shared.TASK-OPPORTUNITY-INFO.OPPORTUNITY-STAGE' | translate}}
                </h3>
                <div class="-ml-2">
                  <p-select [options]="opportunityStageCollection"
                    formControlName="ddlselectedOpportunity"
                    optionLabel="name"
                    styleClass="border-none surface-50"
                    (onChange)="UpdateOpportunityStatge($event,TaskApportunityInfoForm)"
                    aria-label="opportunity-stage-dropdown">
                    <ng-template pTemplate="selectedItem">
                      @if (SelectedOpportunity) {
                        <div>
                          <strong class="text-900" aria-label="opportunity-stage-value">{{SelectedOpportunity.name}}</strong>
                        </div>
                      }
                    </ng-template>
                    <ng-template let-opportunity pTemplate="item">
                      <div class="text-sm" aria-label="opportunity-stage-option">{{opportunity.name}}</div>
                    </ng-template>
                  </p-select>
                </div>
              </div>
            }
            @if (modelData().stage_master_id) {
              <div class="col-6" aria-label="amount-section">
                <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="amount-label">{{'Shared.TASK-OPPORTUNITY-INFO.AMOUNT' | translate}}</h3>
                @if (!amountEdit) {
                  <strong
                    (click)="amountEdit = true"
                    class="text-sm block md:inline md:text-base -mt-2 p-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                    data-testid="amount-display">
                    {{modelData().value_in_minor_currency?(modelData().value_in_minor_currency | currencyformat):(0 | currencyformat)}}
                  </strong>
                }
                @if (amountEdit) {
                  <div class="flex flex-nowrap align-items-stretch border-round border-1 border-300 overflow-hidden" aria-label="amount-edit">
                    <span class="flex align-items-center justify-content-center bg-gray-100 px-3 border-right-1 border-300" aria-label="currency-symbol">{{this.country.currency_symbol}}</span>
                    <app-input-number
                      [formGroup]="TaskApportunityInfoForm"
                      [controlName]="TaskApportunityInfoForm.get('value_in_minor_currency')"
                      [conditionToFormat]="true"
                      [styleClass]="'w-full border-none border-noround'"
                      class="flex-grow-1"
                      aria-label="amount-input">
                    </app-input-number>
                    <button type="button"
                      pButton
                      pRipple
                      icon="fa fa-check"
                      class="px-3 border-none border-noround bg-primary"
                      (click)="UpdateAmount(TaskApportunityInfoForm)"
                      aria-label="save-amount"
                    ></button>
                    <button type="button"
                      pButton
                      pRipple
                      icon="fa fa-times"
                      class="px-3 p-button-danger border-none border-noround  text-danger"
                      (click)="amountEdit = false"
                      aria-label="cancel-amount"
                    ></button>
                  </div>
                }
              </div>
            }
            @if (modelData().stage_master_id) {
              <div class="col-12" aria-label="closure-date-section">
                <h3 class="text-xs text-600 mb-2 font-normal uppercase" aria-label="closure-date-label">
                  {{'Shared.TASK-OPPORTUNITY-INFO.EXPECTED-CLOSURE-MONTH' | translate}}
                </h3>
                @if (!expectedDateEdit) {
                  <strong
                    (click)="expectedDateEdit=true;"
                    class="text-sm block md:inline md:text-base -mt-2 p-1 -ml-1 md:mt-0 cursor-pointer border-round hover:surface-200"
                    data-testid="closure-date-display">
                    <i class="fa fa-calendar-plus mr-2" aria-label="closure-date-icon"></i>
                    {{TaskApportunityInfoForm.get('expected_closure_date').value | datetimeformat:'month-year'}}
                  </strong>
                }
                @if (expectedDateEdit) {
                  <div class="p-inputgroup" aria-label="closure-date-edit">
                    <p-datepicker [showIcon]="true"
                      formControlName="expected_closure_date"
                      styleClass="w-full"
                      dateFormat="MM yy"
                      view="month"
                      placeholder="Select Date"
                      inputStyleClass="text-sm"
                      [inline]="expectedDateEdit"
                      (onSelect)="OnExpectedClosureDateSelect($event)"
                      aria-label="closure-date-picker" />
                  </div>
                }
              </div>
            }
            @if (modelData().stage_master_id) {
              <div class="col-12" aria-label="service-type-section">
                <h3 class="text-xs text-600 mb-2 font-normal uppercase mt-2" aria-label="service-type-label">
                  {{'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN' | translate}}
                </h3>
                <p-autoComplete
                  formControlName="service_type_ids"
                  optionLabel="name_primary_language"
                  styleClass="w-full"
                  [suggestions]="filtertedServiceType"
                  (completeMethod)="filterServiceType($event)"
                  (onSelect)="UpdateServiceType(false, $event, TaskApportunityInfoForm)"
                  (onUnselect)="UpdateServiceType(true, $event, TaskApportunityInfoForm)"
                  [multiple]="true"
                  aria-label="service-type-autocomplete">
                  
                </p-autoComplete>
              </div>
            }
          </div>
        </form>